module.exports = __webpack_public_path__ + "img/AL.09a54c20.png";